import React  from 'react';
import Row from '../Row';
import * as styles from './styles.scss'

const Body = ({
    rows,
    className,
    labels,
    confirmation,
}) => (
    rows.map((row, index) => (
        <div
            key={index}
            className={confirmation?.length ? styles.wrapper : undefined}
        >
            {confirmation[index]}
            <Row
                row={row}
                className={className}
                labels={labels}
            />
        </div>
    ))
);


export default Body;
